import {
  Truck,
  Users,
  ShoppingCart,
  CreditCard,
  Package,
  BarChart3,
  Wallet,
  Settings,
  PiggyBank,
  Receipt,
  PackageCheck,
  Calculator,
  ClipboardList,
  PackagePlus,
  Warehouse
} from "lucide-react";

export interface Module {
  id: number;
  name: string;
  /** Etiqueta corta del menú Inicio (hover / nombre visible). Si falta, se usa `name`. */
  shortName?: string;
  icon: typeof Truck;
  gradient: string;
  route: string;
}

export interface OpenModule {
  id: number;
  module: Module;
  /** Estado opaco por módulo (persistencia / restauración); acotar en el consumidor si hace falta. */
  state?: unknown;
}

/** Módulos que el usuario puede abrir según `modulosPermitidos` (Start Menu / openModule).
 * Superuser KEEP: todos los tiles aunque la lista venga vacía (sin perfil / sin rol).
 * Sin perfil y no elevado: menú vacío (nunca “todos los módulos”).
 */
export function getPermittedModulesForUser(
  modulosPermitidos: number[] | undefined | null,
  opts?: { isElevated?: boolean },
): Module[] {
  if (opts?.isElevated) return availableModules;
  if (!modulosPermitidos?.length) return [];
  return availableModules.filter((m) =>
    modulosPermitidos.some((id) => Number(id) === Number(m.id)),
  );
}

export const availableModules: Module[] = [
  { id: 1, name: "Proveedores", icon: Truck, gradient: "from-blue-500 to-cyan-500", route: "/proveedores" },
  { id: 7, name: "Pedidos", icon: PackagePlus, gradient: "from-sky-500 to-blue-600", route: "/pedidos" },
  { id: 2, name: "Clientes", icon: Users, gradient: "from-purple-500 to-pink-500", route: "/clientes" },
  { id: 3, name: "Ventas", icon: ShoppingCart, gradient: "from-green-500 to-emerald-500", route: "/ventas" },
  { id: 4, name: "Cheques", icon: CreditCard, gradient: "from-orange-500 to-amber-500", route: "/cheques" },
  { id: 5, name: "IVA - DDJJ RG3685", shortName: "DDJJ", icon: Calculator, gradient: "from-red-500 to-rose-500", route: "/iva" },
  { id: 6, name: "Stock", icon: Warehouse, gradient: "from-indigo-500 to-blue-500", route: "/stock" },
  { id: 8, name: "Artículos", icon: Package, gradient: "from-teal-500 to-cyan-500", route: "/articulos" },
  { id: 9, name: "Reportes", icon: BarChart3, gradient: "from-violet-500 to-purple-500", route: "/reportes" },
  { id: 10, name: "Caja & Bancos", icon: Wallet, gradient: "from-emerald-500 to-green-500", route: "/caja-bancos" },
  { id: 11, name: "Opciones", icon: Settings, gradient: "from-gray-500 to-slate-500", route: "/opciones" },
  { id: 12, name: "Presupuestos", icon: ClipboardList, gradient: "from-blue-500 to-indigo-500", route: "/presupuestos" },
  { id: 13, name: "Fondos", icon: PiggyBank, gradient: "from-emerald-500 to-teal-500", route: "/fondos" },
  { id: 14, name: "Recibos", icon: Receipt, gradient: "from-purple-500 to-pink-500", route: "/recibos" },
  { id: 15, name: "Remitos Vtas", icon: PackageCheck, gradient: "from-cyan-500 to-blue-500", route: "/remitos-vtas" },
  // 16 = Dashboard / Inicio: solo matriz de Roles, no tile del menú (home ya es `/`).
];